<div *ngIf="!(1 | walletControl : 'BranchType')" class="quick-register-container text">
  <div class="up-text-row">Daten vervollständigen</div>
  <div class="sub-text-row">Aufgrund behördlicher vorgaben benötigen wir zusätzlich Kundeninformationen von dir:</div>
  <form class="change-password-form" [formGroup]="quickRegisterDatas">
    <div class="slips-section-container">
      <dropdownb3 [fData]="comboType" [fDataValueKey]="'id'" [fDataViewKey]="'name'" fDefaultSelectText=" {{ 'Title' | t }}" formControlName="gender"></dropdownb3>
    </div>
    <inputb3 formControlName="eMail" extraClass="profileInputs" fErrorText="{{ 'Required' | t }}" fPlaceholder="{{ 'Email' | t }}" fInputType="email"></inputb3>
    <inputb3 formControlName="lastName" extraClass="profileInputs" fErrorText="{{ 'Required' | t }}" fPlaceholder="Geburtsname" fInputType="text"></inputb3>
    <ng-container *ngIf="hasBirthplace">
      <inputb3 formControlName="birthPlace" extraClass="profileInputs" fErrorText="{{ 'Required' | t }}" fPlaceholder="Birth Place" fInputType="text"></inputb3>
    </ng-container>
    <ng-container *ngIf="hasCountry">
      <dropdownb3
        formControlName="country"
        fPlaceholder="Country"
        fErrorText="{{ 'Required' | t }}"
        [fData]="this.countryListLangAPI"
        [fDataValueKey]="'CountryId'"
        [fDataViewKey]="'Country'"
        fDefaultSelectText="{{ 'b3000_pick_one' | t }}"></dropdownb3>
    </ng-container>

    <inputb3 formControlName="IsPromotion" fPlaceholder="{{ 'b3000_Register_checkbox_text_3' | t }}" fInputType="checkbox"></inputb3>

    <div class="form-b3 form-field-b3 checkbox">
      <label for="agreement" class="label-b3" for="agreement">
        <div class="text-1">ICH BIN ÜBER 18 JAHRE ALT, HABE DIE AKTUELL GÜLTIGEN</div>
        <a class="text-1" style="text-decoration: underline; font-weight: bold; color: #000" routerLink="/article/{{ 'route_article_footer_5' | t }}" target="_blank">AGB </a>
        <a class="text-1"> UND </a>

        <a class="text-1" style="text-decoration: underline; font-weight: bold; color: #000" routerLink="/article/{{ 'route_article_footer_4' | t }}" target="_blank"
          >DATENSCHUTZERKLÄRUNG.</a
        >
        <div class="text-1">GELESEN UND AKZEPTIERE DIESE.</div>
      </label>
      <div class="input-container checkbox">
        <input
          class="formType_checkbox"
          type="checkbox"
          id="agreement"
          name="agreement"
          required="{{ 'Required' | t }}"
          formControlName="checkBox2"
          placeholder="{{ 'b3000_Register_checkbox_text_2' | t }}" />
      </div>
    </div>
  </form>

  <ng-container *ngIf="quickRegisterDatas.valid; else noValid">
    <div class="btn mobile colored green" (click)="quickRegister()">
      <div class="btn-text mobile-text-white">
        {{ 'Confirm' | t }}
      </div>
    </div>
  </ng-container>
  <ng-template #noValid>
    <div class="btn mobile colored green" style="opacity: 0.5">
      <div class="btn-text mobile-text-white">
        {{ 'Confirm' | t }}
      </div>
    </div>
  </ng-template>
</div>
<div class="credit-main-container text" *ngIf="(1 | walletControl : 'BranchType') || (2 | walletControl : 'BranchType') || (4 | walletControl : 'BranchType')">
  <div class="credit-container text">
    <div class="credit-dropdown-header">
      <div class="credit-header-left-side">{{ 'Settings_Ei' | t }}</div>
      <div class="credit-header-right-side"></div>
    </div>
    <div class="credit-settings-content">
      <div class="selected-wallet-row">
        <div class="left-side">{{ 'b3000_Selected_wallet' | t }}:</div>
        <div class="mid-side">
          <div class="shop-icon">
            <ng-container
              *ngIf="
                this._DataHelper.selectedWallet.BranchType == 1 ||
                this._DataHelper.selectedWallet.BranchType == 2 ||
                this._DataHelper.selectedWallet.BranchType == 3 ||
                this._DataHelper.selectedWallet.BranchType == 4
              ">
              <image-loader-utils url="sports" extraClasses="sports"></image-loader-utils>
            </ng-container>
            <div class="shop-icon" *ngIf="this._DataHelper.selectedWallet.BranchType == 0">
              <image-loader-utils url="shop" extraClasses="shop-icon"></image-loader-utils>
            </div>
          </div>
          <div class="shop-name">
            {{ this._DataHelper.selectedWallet.BranchType === 1 ? ('online_sports' | t) : this._DataHelper.selectedWallet.BrancName }}
          </div>
        </div>
        <div class="right-side">
          {{ this._UserHelper.customerUser.BalanceAmount }}
          {{ this._UserHelper.customerUser.Symbol }}
        </div>
      </div>
      <div class="" *ngFor="let item of this._UserHelper.walletList">
        <div class="selection-container-shop" style="display: flex; width: 100%" (click)="walletSelectChange(item)">
          <div class="select-header-row">
            <div class="left-side">
              <div class="shop-icon" *ngIf="item.BranchType == 1 || item.BranchType == 2 || item.BranchType == 3 || item.BranchType == 4">
                <image-loader-utils url="sports" extraClasses="creditsvg"></image-loader-utils>
              </div>
              <div class="shop-icon" *ngIf="item.BranchType == 0">
                <image-loader-utils url="shop" extraClasses="shop-icon"></image-loader-utils>
              </div>
              <div class="shop-name">{{ item.BranchType == 1 ? ('online_sports' | t) : item.BrancName }}</div>
            </div>
            <div class="right-side">
              <div
                class="radio-dot"
                [ngClass]="{
                  active: item.CustomerId == this._UserHelper.customerUser?.CustomerId
                }">
                <div class="dot"></div>
              </div>
            </div>
          </div>
          <div class="select-info-item-row">
            <div class="left-side">{{ 'Balance' | t }}:</div>
            <div class="right-side">{{ item.Balance | balanceFormat }}</div>
          </div>
          <div class="select-info-item-row">
            <div class="left-side">{{ 'Created_Date' | t }}:</div>
            <div class="right-side">{{ item.CreateDate | dateFormat : 'dd.MM.yy HH:mm' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="verification-container white" *ngIf="false | walletControl : 'IsVerification'">
    <div class="verification-row">
      {{ 'b3000_email_verification_text' | t }}
    </div>
    <ng-container *ngIf="isReSend; else noReSend">
      <div class="button-container" (click)="reSendConfirmation()">
        <div class="btn colored register-button save-changes-button confirm-button">
          <div class="btn-text">
            {{ 'Resend_Code' | t }}
          </div>
        </div>
      </div>

      <!-- <div class="btn mobile colored green">
        <div class="btn-text mobile-text-white">
          {{ "Confirm" | t }}
        </div>
      </div> -->
    </ng-container>
    <ng-template #noReSend>
      <div class="button-container" style="opacity: 0.5">
        <div class="btn colored register-button save-changes-button confirm-button">
          <div class="btn-text">
            {{ 'Resend_Code' | t }}
          </div>
        </div>
      </div>

      <!-- <div class="btn mobile colored green" style="opacity: 0.5">
        <div class="btn-text mobile-text-white">
          {{ "Confirm" | t }}
        </div>
      </div> -->
    </ng-template>
  </div>
  <div class="credit-container text" *ngIf="this._DataHelper.selectedWallet?.BranchType == 1 && this.isIbanCompleted === false && (true | walletControl : 'IsVerification')">
    <div class="credit-dropdown-header" (click)="toggleDropDown(1)">
      <div class="credit-header-left-side">
        {{ 'b3000_account_credit_text_1' | t }}
      </div>
      <div class="credit-header-right-side">
        <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (ibanDropDownIsOpen ? 'down' : 'right')"></image-loader-utils>
      </div>
    </div>
    <div class="credit-iban-content-container" *ngIf="ibanDropDownIsOpen">
      <div class="iban-info-text">
        {{ 'b3000_account_credit_text_2' | t }}
      </div>
      <div class="iban-confirm-container">
        <div class="iban-input-container">
          <inputb3 [(ngModel)]="iban"></inputb3>
        </div>
        <div class="confirm-button abled" *ngIf="iban.length > 0 && iban.slice(0, 2).toUpperCase() === 'DE'; else noIban" (click)="saveIban()">
          <div class="">{{ 'Confirm' | t }}</div>
        </div>
        <ng-template #noIban>
          <div class="confirm-button">{{ 'Confirm' | t }}</div>
          <div class="iban-alert-mesagge" *ngIf="iban.length > 2 && iban.slice(0, 2).toUpperCase() != 'DE'">
            {{ 'b3000_account_credit_text_alert' | t }}
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <ng-container [ngSwitch]="['b500'] | getProductName">
    <ng-container *ngSwitchCase="'b500'"> </ng-container>
    <ng-container *ngSwitchDefault>
      <div
        class="credit-container text"
        *ngIf="
          isIbanCompleted &&
          (true | walletControl : 'IsVerification') &&
          (this._DataHelper.selectedWallet?.BranchType == 1 || this._DataHelper.selectedWallet?.BranchType == 4 || this._DataHelper.selectedWallet?.BranchType == 2)
        ">
        <div class="credit-dropdown-header" (click)="toggleDropDown(3)">
          <div class="credit-header-left-side">
            {{ 'b3000_Deposit_DropDown' | t }}
          </div>
          <div class="credit-header-right-side">
            <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (depositDropDownIsOpen ? 'up' : 'down')"></image-loader-utils>
          </div>
        </div>
        <div class="credit-iban-content-container" *ngIf="depositDropDownIsOpen">
          <!-- *ngIf="this._UserHelper.customerUser.IBAN.length == 0 || !isIbanValid" -->
          <ng-container [ngSwitch]="['wettarena', 'b500', 'cangobet'] | getProductName">
            <ng-container *ngSwitchCase="'wettarena'">
              <deposit-wettarena-comp></deposit-wettarena-comp>
            </ng-container>
            <ng-container *ngSwitchCase="'b500'"></ng-container>
            <ng-container *ngSwitchCase="'cangobet'"></ng-container>
            <ng-container *ngSwitchDefault>
              <deposit-b3000-comp></deposit-b3000-comp>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div
        class="credit-container text"
        *ngIf="
          isIbanCompleted &&
          (true | walletControl : 'IsVerification') &&
          (this._DataHelper.selectedWallet?.BranchType == 1 || this._DataHelper.selectedWallet?.BranchType == 4 || this._DataHelper.selectedWallet?.BranchType == 2)
        ">
        <div class="credit-dropdown-header" (click)="toggleDropDown(2)">
          <div class="credit-header-left-side">{{ 'Withdraw' | t }}</div>
          <div class="credit-header-right-side">
            <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (withdrawDropDownIsOpen ? 'up' : 'down')"></image-loader-utils>
          </div>
        </div>
        <ng-container [ngSwitch]="['wettarena', 'b3000', 'b500', 'cangobet'] | getProductName">
          <ng-container *ngSwitchCase="'wettarena'">
            <withdraw-wettarena-component [isOpen]="withdrawDropDownIsOpen"></withdraw-wettarena-component>
          </ng-container>
          <ng-container *ngSwitchCase="'b500'"></ng-container>
          <ng-container *ngSwitchCase="'cangobet'"></ng-container>
          <ng-container *ngSwitchDefault>
            <withdraw-b3000-component [isOpen]="withdrawDropDownIsOpen"></withdraw-b3000-component>
          </ng-container>
        </ng-container>
      </div>
      <div class="credit-container text" *ngIf="this._DataHelper.selectedWallet?.BranchType == 0 || this._DataHelper.selectedWallet?.BranchType == 2">
        <!-- <div class="credit-dropdown-header" (click)="toggleDropDown(4)">
            <div class="credit-header-left-side">Pay3000</div>
            <div class="credit-header-right-side">
              <div
                [ngClass]="{
                  'svg-arrow-right': !pay3000DropDownIsOpen,
                  'svg-arrow-down': pay3000DropDownIsOpen
                }"
              ></div>
            </div>
          </div> -->
        <!-- <pay3000-component [isOpen]="pay3000DropDownIsOpen"></pay3000-component> -->
      </div>
    </ng-container>
  </ng-container>
</div>
